export default __webpack_public_path__ + "static/media/Kumarakom1.6c17b126.jpg";